<template>
  <!-- Phase 2 - Fee Structure Tracking (#29) -->
  <expandable header="Fee Payment History" class="mt-3">
    <div v-if="isLoading" class="text-center py-3">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="payments.length === 0" class="text-center py-3 text-muted">
      No payment records found.
    </div>
    <b-table
      v-else
      :items="payments"
      :fields="fields"
      striped
      small
      responsive
    >
      <template #cell(TransactionStatus)="{ value }">
        <b-badge :variant="value === 'SUCCESS' ? 'success' : 'danger'">
          {{ value }}
        </b-badge>
      </template>
      <template #cell(TransactionAmount)="{ value }">
        {{ formatCurrency(value) }}
      </template>
    </b-table>
    <!-- Fee Summary -->
    <b-row class="mt-2" v-if="payments.length > 0">
      <b-col cols="12" md="4">
        <div class="bg-light p-2 rounded">
          <small class="text-muted">Total Paid</small>
          <h6 class="mb-0">{{ formatCurrency(totalPaid) }}</h6>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <div class="bg-light p-2 rounded">
          <small class="text-muted">Successful Transactions</small>
          <h6 class="mb-0">{{ successCount }}</h6>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <div class="bg-light p-2 rounded">
          <small class="text-muted">Last Payment Date</small>
          <h6 class="mb-0">{{ lastPaymentDate }}</h6>
        </div>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../Expandable.vue";
import { formatDate } from "../../assets/js/common";
import { FEE_TYPE_NAMES } from "../../assets/constants/payment.constants";
import hospitalService from "../../assets/services/hospital.service";
export default {
  components: { Expandable },
  props: {
    hospitalId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      payments: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "sno", label: "#" },
        { key: "payment_type_name", label: "Fee Type" },
        { key: "TransactionAmount", label: "Amount" },
        { key: "TransactionStatus", label: "Status" },
        { key: "SurePay_TxnId", label: "Transaction ID" },
        { key: "ResponseDateTime", label: "Date" },
      ];
    },
    totalPaid() {
      return this.payments
        .filter((p) => p.TransactionStatus === "SUCCESS")
        .reduce((sum, p) => sum + parseFloat(p.TransactionAmount || 0), 0);
    },
    successCount() {
      return this.payments.filter(
        (p) => p.TransactionStatus === "SUCCESS"
      ).length;
    },
    lastPaymentDate() {
      let paid = this.payments.filter(
        (p) => p.TransactionStatus === "SUCCESS"
      );
      if (paid.length === 0) return "-";
      return formatDate(paid[0].ResponseDateTime);
    },
  },
  methods: {
    formatCurrency(val) {
      return "Rs." + Number(val || 0).toLocaleString("en-IN");
    },
    getPaymentTypeName(type) {
      let item = FEE_TYPE_NAMES.find((f) => f.value == type);
      return item ? item.name : type;
    },
    async fetch() {
      const vm = this;
      if (!vm.hospitalId) return;
      try {
        vm.isLoading = true;
        let { data } = await hospitalService.initPayment({
          hospital_id: vm.hospitalId,
          dml_indicator: "PH",
        });
        vm.isLoading = false;
        if (data.status && data.list) {
          vm.payments = data.list.map((item, i) => {
            item.sno = i + 1;
            item.payment_type_name = vm.getPaymentTypeName(item.payment_type);
            return item;
          });
        }
      } catch (error) {
        vm.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetch();
  },
  watch: {
    hospitalId() {
      this.fetch();
    },
  },
};
</script>
